module.exports = __webpack_public_path__ + "media/images/emblems/Zollikofen-coat_of_arms-51422f4e1170a7d8d4f0fba471b86edb.svg";